import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getProjectCardImage } from '../utils/projectImages';
import './Gallery.css';

const Gallery = ({ projects = [], loading }) => {
  const [filter, setFilter] = useState('All');

  // Ensure projects is an array
  const safeProjects = Array.isArray(projects) ? projects : [];
  
  const projectTypes = ['All', ...new Set(safeProjects.map(p => p.type).filter(Boolean))];

  const filteredProjects = filter === 'All' 
    ? safeProjects 
    : safeProjects.filter(p => p.type === filter);

  if (loading) {
    return (
      <div className="gallery-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading projects...</p>
        </div>
      </div>
    );
  }

  const getImagePath = () => {
    const baseUrl = process.env.PUBLIC_URL || '';
    return `${baseUrl}/images/project.png`;
  };

  const backgroundImageUrl = getImagePath();

  return (
    <div className="gallery-page">
      <section className="gallery-hero">
        <img 
          src={backgroundImageUrl}
          alt="Projects Background"
          className="gallery-hero-background"
          onError={(e) => {
            console.error('Failed to load background image:', backgroundImageUrl);
            e.target.style.display = 'none';
          }}
        />
        <div className="gallery-hero-overlay"></div>
        <div className="gallery-hero-content">
          <h1 className="gallery-title">Our Projects</h1>
          <p className="gallery-subtitle">
            <span className="gallery-subtitle-bg">Explore our portfolio of successful construction projects</span>
          </p>
        </div>
      </section>

      <section className="gallery-section">
        <div className="gallery-container">
          <h2 className="gallery-section-title">Project Portfolio</h2>
          <div className="filter-buttons">
            {projectTypes.map(type => (
              <button
                key={type}
                className={`filter-btn ${filter === type ? 'active' : ''}`}
                onClick={() => setFilter(type)}
              >
                {type}
              </button>
            ))}
          </div>

          {filteredProjects.length === 0 ? (
            <div className="no-projects">
              <p>No projects found.</p>
            </div>
          ) : (
            <div className="projects-grid">
              {filteredProjects.map(project => {
                const cardImage = getProjectCardImage(project.photoDirectory);
                return (
                  <Link
                    key={project.id}
                    to={`/project/${project.id}`}
                    className="project-card"
                  >
                    <div className="project-image">
                      <div className="project-type-badge">{project.type || 'Project'}</div>
                      {cardImage ? (
                        <img 
                          src={cardImage}
                          alt={project.name}
                          className="project-card-img"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextElementSibling.style.display = 'flex';
                          }}
                        />
                      ) : null}
                      <div className="project-placeholder" style={{ display: cardImage ? 'none' : 'flex' }}>
                        <span className="project-icon">🏗️</span>
                      </div>
                      <div className="project-overlay">
                        <span className="project-name-overlay">{project.name}</span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Gallery;
